import './App.css';
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Intro } from "./components/Intro";
import { Services } from "./components/Services";
import { Projects } from "./components/Project";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import { Backdrop } from "./components/Backdrop";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Intro />
        <Services />
        <Projects />
        <Contact />
      </main>
      <Footer />
      <Backdrop />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
